import React from 'react';
import { Check, BookOpen, Scissors, Globe, Sparkles, ListChecks, AlertTriangle, TrendingUp, GraduationCap, BookMarked, Package, MessageCircle, Coffee, Award, Phone } from 'lucide-react';
const modules = [{
  icon: BookOpen,
  title: 'Módulo 1',
  desc: 'Introducción al Mundo de los Alisados'
}, {
  icon: Scissors,
  title: 'Módulo 2',
  desc: 'Conociendo el Cabello antes del Alisado'
}, {
  icon: Globe,
  title: 'Módulo 3',
  desc: 'Comprendiendo el Mercado en EE.UU'
}, {
  icon: Sparkles,
  title: 'Módulo 4',
  desc: 'Tecnologías de Alisado Brasileño'
}, {
  icon: ListChecks,
  title: 'Módulo 5',
  desc: 'Procedimiento Paso a Paso'
}, {
  icon: AlertTriangle,
  title: 'Módulo 6',
  desc: 'Errores Comunes y Cómo Evitarlos'
}, {
  icon: TrendingUp,
  title: 'Módulo 7',
  desc: 'Emprendiendo con Éxito'
}];
const includes = [{
  icon: GraduationCap,
  text: 'Clase práctica VIP (2 días)'
}, {
  icon: BookMarked,
  text: 'Manual de clase'
}, {
  icon: Package,
  text: 'Kit de alisado completo'
}, {
  icon: MessageCircle,
  text: 'Grupo exclusivo de WhatsApp'
}, {
  icon: Coffee,
  text: 'Coffee break & brunch'
}, {
  icon: Award,
  text: 'Certificado de participación'
}];
const learnings = ['Diagnóstico capilar', 'Aplicación y técnica de alisados', 'Restauración capilar: botox e hidratación', 'Cómo vender en el mercado'];
export const Academy = () => {
  return <section id="academia" className="py-20 bg-beige-100 relative overflow-hidden" data-id="element-21">
      {/* Subtle gold glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[500px] bg-[radial-gradient(ellipse_at_top,_rgba(201,166,107,0.18),_transparent_70%)] pointer-events-none" data-id="element-22"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-23">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-24">
          <p className="text-sm tracking-[0.25em] uppercase mb-4 font-semibold text-gold-600" data-id="element-25">
            Master Class
          </p>
          <h2 className="text-4xl md:text-5xl font-serif mb-4 leading-tight" data-id="element-26">
            <span className="metallic-gold-text" data-id="element-27">
              Alisados Orgánicos &amp; Restauración Capilar
            </span>
          </h2>
          <p className="font-serif italic text-xl text-neutral-700 mb-6" data-id="element-28">
            by Stefania Becerra
          </p>
          <div className="w-24 h-1 bg-gold-300 mx-auto rounded-full mb-6" data-id="element-29"></div>
          <p className="text-lg text-neutral-600 max-w-2xl mx-auto font-light" data-id="element-30">
            “Aprende, emprende y gana con esta técnica profesional.”
          </p>

          {/* Premium portrait */}
          <div className="relative flex justify-center mt-12" data-id="element-31">
            {/* Soft gold glow behind portrait */}
            <div className="absolute -inset-6 rounded-[2.5rem] pointer-events-none" style={{
            background: 'radial-gradient(ellipse at center, rgba(201,166,107,0.30), transparent 70%)'
          }} aria-hidden="true" data-id="element-32" />

            {/* Decorative offset rings */}
            <div className="absolute -top-5 -left-5 sm:-left-10 w-32 h-32 rounded-full border border-gold-400/50 hidden sm:block" aria-hidden="true" data-id="element-33" />
            <div className="absolute -bottom-6 -right-5 sm:-right-10 w-24 h-24 rounded-full bg-beige-100/60 border border-gold-300/40 hidden sm:block" aria-hidden="true" data-id="element-34" />

            {/* Portrait frame */}
            <div className="relative rounded-[2rem] overflow-hidden border-2 border-gold-300 bg-beige-100" style={{
            boxShadow: '0 30px 70px -20px rgba(120, 80, 30, 0.35), 0 12px 30px -8px rgba(120, 80, 30, 0.2)'
          }} data-id="element-35">
              <img src="https://cdn.magicpatterns.com/uploads/kMjmL1YEeDDoMMmAKtHUub/stefania22.png" alt="Stefania Becerra, instructora de la Master Class de Alisados Orgánicos" className="w-full h-auto max-w-xs sm:max-w-sm object-cover block" data-id="element-36" />
              {/* Subtle bottom gradient for badge legibility */}
              <div className="absolute inset-x-0 bottom-0 h-32 pointer-events-none" style={{
              background: 'linear-gradient(to top, rgba(60,46,34,0.55), transparent)'
            }} aria-hidden="true" data-id="element-37" />
              {/* Floating brand badge */}
              <div className="absolute bottom-5 left-1/2 -translate-x-1/2 text-center px-6 py-2 rounded-full bg-white/90 backdrop-blur-sm border border-gold-300 shadow-lg" data-id="element-38">
                <span className="block font-serif italic text-xl leading-none metallic-gold-text" data-id="element-39">
                  Stefania Becerra
                </span>
                <span className="block font-serif tracking-widest uppercase text-[10px] mt-0.5 metallic-gold-text-static" data-id="element-40">
                  Instructora
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Modules */}
        <div className="mb-20" data-id="element-41">
          <h3 className="text-2xl md:text-3xl font-serif text-neutral-900 text-center mb-3" data-id="element-42">
            ¿Quieres aprender a transformar el cabello{' '}
            <span className="metallic-gold-text italic" data-id="element-43">como una experta</span>?
          </h3>
          <p className="text-center text-neutral-600 mb-10" data-id="element-44">
            En mi Master Class, te enseñaré:
          </p>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-45">
            {modules.map((mod, idx) => {
            const Icon = mod.icon;
            return <div key={idx} className="bg-white rounded-2xl p-6 shadow-sm border border-beige-200 hover:border-gold-300 hover:shadow-md transition-all" data-id="element-46">
                  <div className="w-12 h-12 bg-beige-100 rounded-xl flex items-center justify-center mb-4" data-id="element-47">
                    <Icon className="w-6 h-6 metallic-gold-icon" data-id="element-48" />
                  </div>
                  <p className="text-xs tracking-widest uppercase font-semibold text-gold-600 mb-1" data-id="element-49">
                    {mod.title}
                  </p>
                  <p className="text-neutral-800 font-medium leading-snug" data-id="element-50">
                    {mod.desc}
                  </p>
                </div>;
          })}
          </div>
        </div>

        {/* What's included + What you'll learn */}
        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-51">
          {/* Includes */}
          <div className="bg-white rounded-3xl p-8 shadow-sm border border-beige-200" data-id="element-52">
            <h3 className="text-2xl font-serif text-neutral-900 mb-6" data-id="element-53">
              ¿Qué incluye?
            </h3>
            <ul className="space-y-4" data-id="element-54">
              {includes.map((item, idx) => {
              const Icon = item.icon;
              return <li key={idx} className="flex items-center" data-id="element-55">
                    <span className="w-8 h-8 rounded-full flex items-center justify-center mr-3 flex-shrink-0" style={{
                  backgroundColor: 'rgba(183,110,121,0.12)'
                }} data-id="element-56">
                      <Check className="w-4 h-4 text-rosegold" data-id="element-57" />
                    </span>
                    <span className="text-neutral-700" data-id="element-58">{item.text}</span>
                  </li>;
            })}
            </ul>
          </div>

          {/* Learnings */}
          <div className="bg-white rounded-3xl p-8 shadow-sm border border-beige-200" data-id="element-59">
            <h3 className="text-2xl font-serif text-neutral-900 mb-6" data-id="element-60">
              ¿Qué aprenderás?
            </h3>
            <ul className="space-y-4" data-id="element-61">
              {learnings.map((item, idx) => <li key={idx} className="flex items-center" data-id="element-62">
                  <span className="w-8 h-8 rounded-full flex items-center justify-center mr-3 flex-shrink-0" style={{
                backgroundColor: 'rgba(183,110,121,0.12)'
              }} data-id="element-63">
                    <Check className="w-4 h-4 text-rosegold" data-id="element-64" />
                  </span>
                  <span className="text-neutral-700" data-id="element-65">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center" data-id="element-66">
          <a href="https://wa.me/13479909488?text=Hola%2C%20quiero%20certificarme%20en%20la%20Master%20Class%20de%20Alisados%20Org%C3%A1nicos%20%E2%9C%A8" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center metallic-gold-button text-white px-10 py-4 rounded-full text-lg font-medium shadow-xl hover:-translate-y-1 transition-all" data-id="element-67">
            Quiero certificarme
          </a>
          <a href="tel:+13479909488" className="mt-5 flex items-center justify-center gap-2 text-neutral-700 hover:text-gold-600 transition-colors" data-id="element-68">
            <Phone className="w-4 h-4 metallic-gold-icon" data-id="element-69" />
            <span className="font-medium" data-id="element-70">(347) 990-9488</span>
          </a>
        </div>

        {/* Premium closing separator */}
        <div className="mt-16 flex flex-col items-center" data-id="element-71">
          <div className="flex items-center w-full max-w-md" data-id="element-72">
            <span className="flex-1 h-px bg-gradient-to-r from-transparent to-gold-300" data-id="element-73" />
            <Sparkles className="w-5 h-5 mx-4 metallic-gold-icon" data-id="element-74" />
            <span className="flex-1 h-px bg-gradient-to-l from-transparent to-gold-300" data-id="element-75" />
          </div>
          <p className="mt-6 font-serif italic text-lg md:text-xl text-center metallic-gold-shimmer" data-id="element-76">
            Convierte tu pasión en una profesión rentable.
          </p>
        </div>
      </div>
    </section>;
};